import React, { useState } from 'react'
import { connect } from 'react-redux'
import { connectResource } from '../utils/resource'
import { compose } from 'redux'
import classnames from 'classnames'

import SidebarOnlyLayout from './SidebarOnlyLayout'

const SidebarOnlyLayoutContainer = (props) => {
  const [sidebarHidden, setSidebarHidden] = useState(false)
  const [minimize, setMinimize] = useState(true)
  const [openDropdown, setOpenDropdown] = useState(null)

  const toggleSidebar = () => {
    const newSidebarHidden = !sidebarHidden
    setSidebarHidden(newSidebarHidden)
  }

  const toggleMinimizeSidebar = () => {
    setMinimize(!minimize)
  }

  const toggleDropdown = (key) => {
    setOpenDropdown(openDropdown === key ? null : key)
  }

  const dropdown = {}
  if (openDropdown) {
    dropdown[openDropdown] = true
  }

  return (
    <SidebarOnlyLayout
      {...props}
      sidebarHidden={sidebarHidden}
      minimize={minimize}
      dropdown={dropdown}
      toggleSidebar={toggleSidebar}
      toggleMinimizeSidebar={toggleMinimizeSidebar}
      toggleDropdown={toggleDropdown}
      appClassName={classnames('app', {
        'sidebar-hidden': sidebarHidden,
        'brand-minimized sidebar-minimized': minimize,
      })}
    />
  )
}

export default compose(
  connectResource({ namespace: 'user', endpoint: 'users', prefetch: false }),
  connect(null, (dispatch) => ({ dispatch })),
)(SidebarOnlyLayoutContainer)
